
import Vue from 'vue'
import TopPageArticle from '@/pages/top/components/TopPageArticle.vue'
// import TopPageNotice from '@/pages/top/components/TopPageNotice.vue'
// import TopPageFeatured from '@/pages/top/components/TopPageFeatured.vue'
// import SearchControl from '@/pages/top/components/SearchControl.vue'
// import FacetsLink from '@/components/facets/FacetsLink.vue'
import TopPageNovelty from '@/pages/top/components/TopPageNovelty.vue'
import TopPageFaq from '@/pages/top/components/TopPageFaq.vue'
import HistoryProduct from '@/pages/top/components/HistoryProduct.vue'
import BrandsProduct from '@/pages/top/components/BrandsProduct.vue'
import { Article, TopProducts, TopProductItem } from '@/pages/top/types'
import { MaxQuantityPrice } from '@/types/maxQuantityPrice'
import { Announcement } from '@/types/announcements'
import { BQ_EVENT_NAMES, raksulBQEventTracker} from '@/utils'


interface Observer {
  root: Element | Document | null;
  rootMargin: string;
  thresholds: ReadonlyArray<number>;
  disconnect(): void;
  observe(target: Element): void;
  unobserve(target: Element): void;
}
export default Vue.extend({
  name: 'TopPageMain',
  components: {
    // TopPageNotice,
    // TopPageFeatured,
    // SearchControl,
    // FacetsLink,
    TopPageArticle,
    TopPageNovelty,
    TopPageFaq,
    HistoryProduct,
    BrandsProduct
  },
  props: {
    productCategories: {
      type: Array,
      required: true
    },
    articlesData: {
      type: Array as () => Article[],
      required: true
    },
    announcementsData: {
      type: Array as () => Announcement[],
      required: true
    },
    maxQuantityPrice: {
      type: Object as () => MaxQuantityPrice,
      required: true
    },
    // flagTopSearch: {
    //   type: Boolean,
    //   required: true
    // },
    historyProducts: {
      type: Array as () => TopProductItem[],
      required: true
    },
    topProducts: {
      type: Array as () => TopProducts[],
      required: true
    }
  },
  data(): {
    trackProductIds: Array<number>,
    calcTimeInterval: number | null,
    observerHandler: Observer | null
  }{
    return {
      trackProductIds: [],
      calcTimeInterval: null,
      observerHandler: null
    }
  },
  computed: {
    noticeInfo(): Announcement[] {
      return this.announcementsData.filter(item => {
        return item.announcement_type === 'info'
      })
    }
  },
  watch: {
    trackProductIds(value) {
      this.clearTrackingInterval()
      if (value.length) this.trackingInterval()
    }
  },
  mounted() {
    window.addEventListener('load', () => {
      this.createIntersectionObserver()
    })

    window.addEventListener('beforeunload', () => {
      this.clearTrackingInterval()
      this.observerHandler?.disconnect()
      this.checkTrackProductIds()
    })
  },
  methods: {
    createIntersectionObserver() {
      const intersectOptions = {
        root: null,
        threshold: 1.0
      }
      this.observerHandler = new IntersectionObserver(this.intersectCallback, intersectOptions)
      const targetElements = document.querySelectorAll('.tp-ProductCard')
      targetElements.forEach(targetElement => {
        this.observerHandler?.observe(targetElement)
      })
    },
    //@ts-ignore
    intersectCallback(entries, observer) {
      entries.forEach((entry: any) => {
        if (entry.isIntersecting) {
          const targetProductId = entry.target.dataset.productId
          this.trackProductIds.push(targetProductId)
          observer.unobserve(entry.target)
        }
      })
    },
    checkTrackProductIds() {
      if (this.trackProductIds.length) {
        this.trackingProductView()
      }
    },
    trackingProductView() {
      const formatTrackProductIds = JSON.stringify(this.trackProductIds)
      raksulBQEventTracker({
        eventName: BQ_EVENT_NAMES.VIEW_MERCHANDISE,
        data: {
          productIds: formatTrackProductIds
        }
      })
      this.trackProductIds = []
    },
    trackingInterval() {
      this.calcTimeInterval = window.setInterval(() => {
        this.checkTrackProductIds()
      }, 2000)
    },
    clearTrackingInterval() {
      clearInterval(this.calcTimeInterval!)
    }
  }
})
